module.exports = __webpack_public_path__ + "img/shrimp_th_new_0008.bf91e8ec.png";